<template>
    <div class="outer-box" >
      <h4>Get verification code for phone</h4>
  
      <div class="inner-box" style="text-align: left; width: 500px;">
        <b-alert show variant="danger">
          Please ensure that the customer owns this mobile number before giving verification code
        </b-alert>
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="mobile number with country code"
          v-model="phoneNo"
        />
        <button class="btn btn-primary mt-4" @click="fetchPhoneVerificationCode" :disabled="!phoneNo || processing">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else> Fetch Verification Code </span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import { OnboardingService } from "@/services";
  import * as moment from "moment";
  export default {
    data() {
      return {
        moment,
        phoneNo: '',
        processing: false,
        response: null
      };
    },
    methods: {
      async fetchPhoneVerificationCode(){
        try {
            this.processing = true
            let phoneNo = this.phoneNo.split(" ").join('')
            const {data} = await OnboardingService.fetchPhoneVerificationCode(phoneNo);

            if(data.success) {
                this.response = {
                  otp: data.result.data.otp,
                  companyId: data.result.data.companyId,
                  verificationMode: data.result.data.verificationMode,
                  verificationValue: data.result.data.verificationValue,
                  createdAt: moment(data.result.data.createdAt).format('DD-MMM-YYYY HH:mm:ss Z'),
                  hasExpired: data.result.data.isExpire,
                }
            } else {
                this.response = data.message
            }

            this.processing = false;
        } catch (error) {
            this.processing = false;
            console.error(error);
        }
      }
    }
  }
  </script>
  
  <style>
  </style>
  